import { render } from "./Overview.vue?vue&type=template&id=29ae10cf"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
script.render = render

export default script